import { render, staticRenderFns } from "./CardOrderUpdateModal.vue?vue&type=template&id=3c126cf3"
import script from "./CardOrderUpdateModal.vue?vue&type=script&lang=js"
export * from "./CardOrderUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports